import type { AppRoleName } from "@shared/schemas/auth";

/**
 * The role names people read, separate from the ones the API uses.
 *
 * `PRODUCT_OWNER` is a database enum; "Product owner" is the thing to put in a
 * dropdown. Kept in one place so the allow-list select, the users table and the
 * audit filter cannot describe the same role three different ways.
 */
export const ROLE_LABEL: Record<AppRoleName, string> = {
  VIEWER: "Viewer",
  PRODUCT_OWNER: "Product owner",
  ADMIN: "Administrator",
};

/** What the role actually lets them do — a title attribute, not a manual. */
export const ROLE_HINT: Record<AppRoleName, string> = {
  VIEWER: "Builds and shares their own scenarios.",
  PRODUCT_OWNER: "Also creates products and curates baselines.",
  ADMIN: "Also manages the allow list and sees the audit log.",
};

export const ROLE_ORDER: readonly AppRoleName[] = ["VIEWER", "PRODUCT_OWNER", "ADMIN"];
